import React, { useEffect, useState } from 'react';
import { Row, Col, Card, Space, DatePicker, Drawer, Form, Input, Select, Radio, message, Modal, Pagination, Tabs } from 'antd';
import { Table, Button } from 'antd';
import BreadcrumbCustom from '../../components/widget/BreadcrumbCustom';
import { DownOutlined, ExclamationCircleOutlined, PlusOutlined, SearchOutlined } from '@ant-design/icons';
import { ITeachClass, IDataView, getDataView, IScheduleColumn, ITeachClassCourse, ITeacherData, ITeachClassData, ITeachClassCourseData } from '../../service/api/teachClass';
import moment from 'moment';
import { ITeacher, listTeachers } from '../../service/api/teacher';
import { FormInstance } from 'antd/lib/form/Form';
import { IStore, listStores } from '../../service/api/store';
const { confirm } = Modal;
const { Option } = Select;
const { RangePicker } = DatePicker;

interface ITeachClassListProps {
  visible: boolean
  setVisible: (visible: boolean) => void;
}
const TeacherDataList: React.FC<ITeachClassListProps> = ({
  visible,
  setVisible,
}) => {
  const [dataView, setDataView] = useState<IDataView>();
  const [stores, setStores] = useState<IStore[]>();
  const [storeId, setStoreId] = useState<number>();
  const [startDate, setStartDate] = useState<string>();
  const [endDate, setEndDate] = useState<string>();

  useEffect(() => {
    loadData();
  }, []);

  const loadData = () => {
    getDataView(startDate, endDate, storeId).then((info: any) => {
      setDataView(info?.data);
    });
    listStores().then((info: any) => {
      setStores(info?.data);
    });
  }

  const handleSelectTime = (value: any, dateString: any) => {
    console.log('选择的时间：', value)
    console.log('选择的时间：', dateString)
    if (value) {
      setStartDate(moment(new Date(value[0])).format('YYYY-MM-DD'));
      setEndDate(moment(new Date(value[1])).format('YYYY-MM-DD'));
    } else {
      setStartDate(undefined);
      setEndDate(undefined);
    }
  }

  // 下拉框值
  const storeOptions = stores?.map((store) =>
    <Option key={store.id} value={store.id}>{store.name}</Option>);

  const loadTeacher = dataView?.teachers?.map((teacher: ITeacherData) => {
    return <Card size="small" title={teacher.name} bordered={false} style={{ minWidth: '330px', marginRight: '10px', border: "1px solid #F0EFEF" }}>
      参与班级数：{teacher.teachClassCount}&nbsp;&nbsp;&nbsp;&nbsp;完成课时数：{teacher.courseHourCount}&nbsp;&nbsp;&nbsp;&nbsp;<br />
      负责学员数：{teacher.studentCount}&nbsp;&nbsp;&nbsp;&nbsp;学员出勤人次：{teacher.punchRecordCount} &nbsp;&nbsp;&nbsp;&nbsp;<br />
      课消金额数：{teacher.courseCostMoney} &nbsp;&nbsp;&nbsp;&nbsp;
      <hr />
      {teacher.teachClasss.length != 0 ?
        teacher.teachClasss?.map((teachClass: ITeachClassData) => {
          return <div>
            <b>[{teachClass.storeName}]</b><br />
            <b>{teachClass.name} [{teachClass.studentCount}人] [{teachClass.message}]</b><br />
            {teachClass.teachClassCourses.length != 0 ?
              teachClass.teachClassCourses?.map((item: ITeachClassCourseData) => {
                return <div>{item.message}<br /></div>
              }) : <div>暂无数据<br /></div>}
            <br />
          </div>
        })
        : '暂无数据'
      }
    </Card>
  })

  return (
    <Card bordered={false} style={{ display: "flex" }}>
      <div style={{ display: "flex" }}>
        <Card  bordered={true} style={{ width: '740px', height: '80px', borderColor: '#F0EFEF' }}>
          <div style={{ marginTop:'-17px' }} >
          {/* <span style={{ fontSize: '16px' }}>参与班级数：</span><span style={{ fontSize: '22px' }}>{dataView?.totalTeachClassCount}&nbsp;&nbsp;&nbsp;</span> */}
          <span style={{ fontSize: '14px' }}>完成课时数：</span><span style={{ fontSize: '18px' }}>{dataView?.totalCourseHourCount}&nbsp;&nbsp;&nbsp;</span>
          <span style={{ fontSize: '14px' }}>参与学员数：</span><span style={{ fontSize: '14px' }}>{dataView?.totalStudentCount}&nbsp;&nbsp;&nbsp;</span>
          <span style={{ fontSize: '14px' }}>学员出勤人次：</span><span style={{ fontSize: '14px' }}>{dataView?.totalPunchRecordCount}&nbsp;&nbsp;&nbsp;</span><br/>
          
          <span style={{ fontSize: '14px' }}>无效课消金额：</span><span style={{ fontSize: '22px' }}>{dataView?.totalInvalidCostMoney}&nbsp;&nbsp;&nbsp;</span>
          <span style={{ fontSize: '14px' }}>总课消金额：</span><span style={{ fontSize: '22px' }}>{dataView?.totalCostMoney}</span><span style={{ fontSize: '14px' }}>（正常课消：{dataView?.totalCourseCostMoney} + 额外课消：{dataView?.totalExtraCostMoney}）</span>
          </div>
        </Card>
        <Card bordered={true} style={{ width: '630px', height: '80px', borderColor: '#F0EFEF', marginLeft: '20px' }}>
          <RangePicker
            format="YYYY-MM-DD"
            onChange={handleSelectTime}
          />
          <Select placeholder="全部校区"
            style={{ width: 160, marginLeft: '20px' }} onChange={(value) => {
              setStoreId(Number(value));
            }} allowClear>
            {storeOptions}
          </Select>
          <Button type="ghost" style={{ width: 100, marginLeft: '20px' }} icon={<SearchOutlined />} onClick={() => {
            loadData();
          }}>搜索</Button>
        </Card>
      </div>
      <div style={{ display: "flex", marginTop: '5px' }}>
        <div style={{ width: '100px', height: '5px', backgroundColor: '#EA0000', alignSelf: 'center' }}></div>
        <div style={{ fontWeight: 'bold' }}>&nbsp;教师汇总&nbsp;</div>
        <div style={{ width: '100px', height: '5px', backgroundColor: '#EA0000', alignSelf: 'center' }}></div>
      </div>
      <div style={{ display: "flex", width: '1500px', overflow: 'scroll', marginTop: '10px' }}>
        {loadTeacher}
      </div>
      {/* <Table dataSource={data} columns={columns} pagination={false} scroll={{ x: 'true' }}/> */}
      <div style={{ display: "flex", justifyContent: "flex-end", paddingTop: "10px" }} />
    </Card>
  );
};

export default TeacherDataList;
